import { SAMAClient } from '@sama-communications/sdk';
import type { Chat } from '../../types';

export default class BlockList {
  private samaClient: SAMAClient;

  constructor(samaClient: SAMAClient) {
    this.samaClient = samaClient;
  }

  public async block(userId: Chat.UserId): Promise<void>;
  public async block(userIds: Chat.UserId[]): Promise<void>;
  public async block(userIds: Chat.UserId | Chat.UserId[]): Promise<void> {
    if (!Array.isArray(userIds)) {
      userIds = [userIds];
    }

    await this.samaClient.blockUsers(userIds);
  }

  public async unblock(userId: Chat.UserId): Promise<void>;
  public async unblock(userIds: Chat.UserId[]): Promise<void>;
  public async unblock(userIds: Chat.UserId | Chat.UserId[]): Promise<void> {
    if (!Array.isArray(userIds)) {
      userIds = [userIds];
    }

    await this.samaClient.unblockUsers(userIds);
  }

  public async list(): Promise<Chat.UserId[]> {
    const usersIds = await this.samaClient.blockList();
    return usersIds;
  }
}
